import { useDispatch, useSelector } from 'react-redux';
import getAwardCards from './getAwardCards';

export const useAwardsCards = navigate => {
    const dispatch = useDispatch();
    const currentUser = useSelector(s => s.user.currentUser);
    const authInfoLoaded = useSelector(s => s.Auth.authInfoLoaded);
    const authInProgress = useSelector(s => s.Auth.authInProgress);
    const ownListings = useSelector(s => {
        try {
            return Object.values(s.ManageListingsPage.ownEntities?.ownListing || {});
        } catch (e) {
            return [];
        }
    });
    const showAwardCards = authInfoLoaded && !authInProgress;

    return showAwardCards
        ? getAwardCards({ navigate, currentUser, ownListings, dispatch }).filter(({ show }) => show)
        : null;
};
